<bgo-hero-cover
  [title]="content.title"
  [description]="content.description"
  [showPartnership]="hasCustomPartnershipLogo"
  *transloco="let t"
>
  <bgo-hero-call-to-action-section>
    @if (content.primaryCallToAction) {
      <cft-call-to-action
        callToActionStyle="button"
        buttonStyle="hero"
        [callToAction]="content.primaryCallToAction"
      ></cft-call-to-action>
    }
    @if (content.secondaryCallToAction) {
      <cft-call-to-action
        callToActionStyle="button"
        [callToAction]="content.secondaryCallToAction"
      ></cft-call-to-action>
    }
  </bgo-hero-call-to-action-section>

  <bgo-hero-mobiliar-partnership></bgo-hero-mobiliar-partnership>
  @if (hasCustomPartnershipLogo) {
    <bgo-hero-partnership [title]="t('categoryLandingPage.inPartnershipWith')">
      <img
        [ngSrc]="content.partnershipImage!.url"
        [alt]="content.partnershipImage!.title"
        content="logo"
        fill
        priority
      />
    </bgo-hero-partnership>
  }
  <img
    [ngSrc]="content.bannerImage.url"
    [alt]="content.bannerImage.title"
    class="banner-image"
    content="background-image"
    fill
    priority
  />
  <bgo-hero-selling-point></bgo-hero-selling-point>
</bgo-hero-cover>
